module.exports = __webpack_public_path__ + "img/spin-btn.cab4ecb9.png";